import { render, staticRenderFns } from "./HeaderOffers.vue?vue&type=template&id=2ffee6df&scoped=true"
import script from "./HeaderOffers.vue?vue&type=script&lang=ts"
export * from "./HeaderOffers.vue?vue&type=script&lang=ts"
import style0 from "./HeaderOffers.vue?vue&type=style&index=0&id=2ffee6df&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffee6df",
  null
  
)

export default component.exports